import gql from 'graphql-tag';

export const SITE_PRODUCT_LIGHT_FRAGMENT = gql`
    fragment SiteProductLight on SiteProduct {
        productId
        product {
            _id
            fullname
            state
            flow
        }
        targetStock
        stock
        availableStock {
            isUnlimited
            value
        }
        latestStockVariations {
            _id
            createdAt
            delta
            type
            ref
            explanation
            columnInventoryStockId
        }
    }
`;

export const SITE_PRODUCT_FRAGMENT = gql`
    fragment SiteProduct on SiteProduct {
        productId
        product {
            _id
            fullname
            state
            flow
        }
        targetStock
        stock
        availableStock {
            isUnlimited
            value
            details {
                dailyStocks
                orderedStocks
                realRecurringOrders
                predictionRecurringOrders
                realPunctualOrders
                predictionPunctualOrders
                realStoreTargetNotPrepared
                realStoreTargetPrepared
                predictionStoreTarget
                storeMenu
                preparationDate
                preparationDateUsedIndex
                soonestRestockedDate
                soonestRestockedDateUsedIndex
                usedRecurringOrders
                usedPunctualOrders
                usedStoreTarget
                usedStoreMenu
            }
        }
        latestStockVariations {
            _id
            createdAt
            delta
            type
            ref
            explanation
            columnInventoryStockId
        }
    }
`;
